import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'
import classNames from 'classnames'

type Props = {
  color: 'blue' | 'green' | 'yellow' | 'orange'
  label: string
}

const LightTag: FC<Props> = React.memo((props) => {
  const { color, label } = props
  return (
    <span
      className={classNames({
        [styles.tag__blue_light]: color === 'blue',
        [styles.tag__green_light]: color === 'green',
        [styles.tag__yellow_light]: color === 'yellow',
        [styles.tag__orange_light]: color === 'orange',
      })}
      data-cy={`light-tag-${label}`}
    >
      {label}
    </span>
  )
})

export default LightTag
